import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { filter, first, switchMap } from 'rxjs/operators';
import { ApplicationService } from '.';
import { AuthService } from '../../auth/services';
import { Application } from '../models';

@Injectable({
    providedIn: 'root'
})
export class CurrentApplicationService {
    latest = new BehaviorSubject<Application | undefined>(undefined);
    currentApplicationId: number | undefined;

    constructor(
        private readonly _applicationService: ApplicationService,
        private readonly _auth: AuthService
    ) {}

    load() {
        this._auth.user$
            .pipe(
                filter((user) => user != null),
                first(),
                switchMap((user) => {
                    if (user?.userId) {
                        return this._applicationService.getCurrentApplication(
                            user.userId
                        );
                    } else {
                        return of(null);
                    }
                })
            )
            .subscribe((application: Application) => {
                this.currentApplicationId = application.applicationId;
                this.latest.next(application);
            });
    }

    reset() {
        this.latest = new BehaviorSubject<Application | undefined>(undefined);
    }
}
